// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"K0-z","displaySixCardTiles":"L0-z"};